export default {"src":"/_next/static/media/logo-lodz.e90c8525.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};